<div class="content pos-relative m-30 flex flex-col full-grow-no-shrink-no-basis">
  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="sourceKey"
                           sortFieldKey="LastSent"
                           sortDirection="desc"
                           [invalidateSubject]="invalidateSubject"
                           (valueChanged)="onGridCellValueChange($event)"
    >
    </particle-virtual-grid>
  </div>
</div>



